import styled from 'styled-components'
import Flex from 'components/Flex'
import Button from 'components/Button'
import { COLORS } from 'theme'

export const Wrapper = styled(Flex)`
  background: #ffffff;
  border: 1px solid #e6e7ea;
  border-radius: 10px;
  padding: 15px;
  margin-bottom: 15px;
  cursor: pointer;
  pointer-events: ${props => (props?.pointer ? 'none' : '')};
  opacity: ${props => (props?.opacity ? '0.5' : '')};
`

export const IconWrapper = styled(Flex)`
  background: #f2f3f5;
  border-radius: 10px;
  padding: ${props => (props?.padding ? '10px' : '14px')};
  margin-right: 10px;
`

export const TextWrapper = styled(Flex)`
  font-weight: 600;
  font-size: 15px;
  line-height: 18px;
  color: #010e30;
  padding-bottom: 3px;
`

export const SubTextWrapper = styled(Flex)`
  font-weight: 400;
  font-size: 14px;
  line-height: 20px;
  color: #999fac;
`

export const Icon = styled(Flex)`
  background: #f2f3f5;
  border-radius: 10px;
  padding: 7px;
  margin-left: 16px;
`

export const InfoSection = styled(Flex)`
  gap: 5px;
  justify-content: space-between;
  align-items: center;
  border: 2px solid ${COLORS.PAGE_BORDER};
  border-radius: 4px;
  padding: 0.8rem 0.5rem;
  background-color: ${COLORS.PRIMARY_GREY_T_98};
  margin-bottom: 1rem;
`
export const SmallButtons = styled(Button.Default)`
  background: ${COLORS.WHITE};
  padding: 9px;
  border-radius: 50%;
  border: ${props => !props.border && 'none'};
  width: 40px;
  height: 40px;
  min-width: 40px;
  min-height: 40px;
  > div {
    margin-left: 0;
  }
`
export const SampleDocContainer = styled.div`
  line-height: 1.3rem;
`
export const BoldText = styled.div`
  font-weight: 700;
  font-size: 0.8rem;
`
export const LightText = styled.div`
  color: ${COLORS.GREY_T_60};
  font-size: 0.8rem;
  font-weight: 600;
`